<template>
    <div class="card shadow h-100 d-flex flex-column container">
        <AddUser v-if="!this.evt.isArchived" ref="AddUser" class="my-3" :eventId="evt.id" @create_ok="refreshUserList" />
        <div class="row mh-100 overflow-auto p-3">
            <div v-if="users.length == 0" class="col-12">
                <div class="alert alert-warning">{{ $t("deviceUserlistEmpty") }}</div> 
            </div>

            <div v-for="user in users" :key="user.id" class="p-0 card col-md-4 shadow-sm" role="button" v-on:click="updateUser(user)">
                <div v-if="!user.isRobotUser" class="k4-deviceUserCard border border-dark row align-items-center m-1">
                    <div class="col-8 text-center p-2">
                        <span>{{user.name}}</span>
                    </div>
                    <div class="col-4 text-center bg-primary-dark text-white p-2">
                        <span v-if="user.checkpoints > 0" class="badge bg-white text-black border" title="number of attached checkpoints">{{user.checkpoints}} cp</span>
                        <span v-if="user.checkpoints == 0" class="badge badge-warning" title="no checkpoint for this user">no cp</span>
                        <p class="m-0">{{user.pin}}</p>
                    </div>
                </div>
                <div v-else class="k4-deviceUserCard border border-dark row align-items-center m-1">
                    <div class="col-8 text-center p-2">
                        <span><font-awesome-icon class="k4-robotIcon" :icon="['fas','robot']" size="1x" /> {{user.name}}</span>
                    </div>
                    <div class="col-4 text-center bg-gray-dark text-white p-2">
                        <span v-if="user.checkpoints > 0" class="badge bg-white text-black bg-white border" title="number of attached checkpoints">{{user.checkpoints}} cp</span>
                        <span v-if="user.checkpoints == 0" class="badge badge-warning" title="no checkpoint for this user">no cp</span>
                        <p class="m-0">{{user.pin}}</p>
                    </div>
                </div>
            </div>
        </div>
        <UpdatePinUser ref="updatePinUserModal" @action_ok="refreshUserList" @delete_ok="refreshUserList" :isReadOnly="evt.isArchived"/>
        <UpdatePinRobot ref="updatePinRobotModal" @action_ok="refreshUserList" @delete_ok="refreshUserList" :evt="evt" :isReadOnly="evt.isArchived"/>
    </div>
</template>

<script>
    import UserService from '../../services/user.service';
    import AddUser from './AddPinUser';
    import UpdatePinUser from './UpdatePinUser';
    import UpdatePinRobot from './UpdatePinRobot';
    import utilMixin from '../../mixins/utils.mixins';
    import { mapGetters } from 'vuex';

    export default {
        name:'DeviceUserList',
        mixins: [utilMixin],
        props : ['evt'],
        components:{ AddUser, UpdatePinUser, UpdatePinRobot },
        data : function(){
            return {
                users : [],
                IsRobotEnabled : false
            }
        },
        watch: {
            event : function(val){
                if(val && val.id){
                    this.refreshUserList();
                }
            }
        },
        created: function(){
            if(this.evt && this.evt.id){
                this.refreshUserList();
            }
        },
        methods: {
            refreshUserList : function(){
                UserService.getUsersByEvent(this.evt.id).then(
                    resp => {
                        var response = resp.status ? resp : resp.response;
                        if(response.status == 200){
                            this.users = response.data;
                        }
                    },
                    error => {
                        this.showToast(this.$t('error'), error.data,'danger');
                    }
                );
            },
            updateUser : function(user) {
                if(user.isRobotUser){
                    this.$refs.updatePinRobotModal.showModal();
                    this.$refs.updatePinRobotModal.user=user;
                } 
                else {
                    this.$refs.updatePinUserModal.showModal();
                    this.$refs.updatePinUserModal.user=user;
                }
            }
        },
        computed: {
            ...mapGetters({
                checkpoints: 'getCheckpoints'
            })
        }
    }
</script>

<style scoped>
    .card {
        overflow: visible;
    }
    .k4-deviceUserCard {
        box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px;
    }
    .k4-deviceUserCard:hover {
        box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
    }
    .k4-robotIcon {
        color: #598cd9;
    }
</style>
